import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { authenticationReducer } from '@app/core/authentication/authentication.slice';
import { baseApi } from '@service/base-api.service';
import { cpmsBoChannelSlice } from '@service/cpms-bo-channel.slice';
import { cpmsBoChargePointSlice } from '@service/cpms-bo-charge-point.slice';
import { cpmsBoCustomerSlice } from '@service/cpms-bo-customer.slice';
import { cpmsBoLocationSlice } from '@service/cpms-bo-location.slice';
import { cpmsBoNetworkSlice } from '@service/cpms-bo-network.slice';
import { cpmsBoRoleSlice } from '@service/cpms-bo-role.slice';
import { cpmsBoTariffSlice } from '@service/cpms-bo-tariff.slice';
import { cpmsBoTransactionSlice } from '@service/cpms-bo-transaction.slice';
import { cpmsBoUserSlice } from '@service/cpms-bo-user.slice';
import { emspBoCpoSlice } from '@service/emsp-bo-cpo.slice';

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [cpmsBoChannelSlice.reducerPath]: cpmsBoChannelSlice.reducer,
  [cpmsBoChargePointSlice.reducerPath]: cpmsBoChargePointSlice.reducer,
  [cpmsBoCustomerSlice.reducerPath]: cpmsBoCustomerSlice.reducer,
  [cpmsBoLocationSlice.reducerPath]: cpmsBoLocationSlice.reducer,
  [cpmsBoNetworkSlice.reducerPath]: cpmsBoNetworkSlice.reducer,
  [cpmsBoRoleSlice.reducerPath]: cpmsBoRoleSlice.reducer,
  [cpmsBoTariffSlice.reducerPath]: cpmsBoTariffSlice.reducer,
  [cpmsBoTransactionSlice.reducerPath]: cpmsBoTransactionSlice.reducer,
  [cpmsBoUserSlice.reducerPath]: cpmsBoUserSlice.reducer,
  [emspBoCpoSlice.reducerPath]: emspBoCpoSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const makeStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(baseApi.middleware),
  });

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];

// The app uses the singleton below; tests build a fresh store per test through this factory
// so the RTK Query cache never leaks between them.
export const createAppStore = (preloadedState?: Partial<RootState>): AppStore =>
  makeStore(preloadedState);

export const store = createAppStore();
